import { createContext, useContext, useEffect, useState } from "react";
import {
	applyThemeConfig,
	fetchThemeConfig,
} from "../services/themeConfigService";

const PUBLIC_PATH = import.meta.env.VITE_PUBLIC_PATH ?? "/";

const DEFAULT_LOGO_LOGIN = `${PUBLIC_PATH}assets/logo-app-login.svg`;
const DEFAULT_LOGO_MENU = `${PUBLIC_PATH}assets/logo-app-menu.svg`;
const DEFAULT_APP_NAME = "Wisephere";

interface ThemeConfigContextValue {
	centeredLogin: boolean;
	customLogo: boolean;
	logoLogin: string;
	logoMenu: string;
	enterpriseName: string;
}

const ThemeConfigContext = createContext<ThemeConfigContextValue>({
	centeredLogin: true,
	customLogo: false,
	logoLogin: DEFAULT_LOGO_LOGIN,
	logoMenu: DEFAULT_LOGO_MENU,
	enterpriseName: DEFAULT_APP_NAME,
});

export function ThemeConfigProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	const [centeredLogin, setcenteredLogin] = useState(false);
	const [customLogo, setCustomLogo] = useState(false);
	const [logoLogin, setLogoLogin] = useState(DEFAULT_LOGO_LOGIN);
	const [logoMenu, setLogoMenu] = useState(DEFAULT_LOGO_MENU);
	const [enterpriseName, setEnterpriseName] = useState("");

	useEffect(() => {
		fetchThemeConfig().then((config) => {
			if (!config) return;
			applyThemeConfig(config);
			setcenteredLogin(config.centeredLogin ?? false);
			setCustomLogo(config.customLogo ?? false);
			if (config.enterpriseName) setEnterpriseName(config.enterpriseName);
			if (config.customLogo) {
				setLogoLogin(
					config.logoLogin
						? `${PUBLIC_PATH}assets/theme/${config.logoLogin}`
						: "",
				);
				setLogoMenu(
					config.logoMenu
						? `${PUBLIC_PATH}assets/theme/${config.logoMenu}`
						: "",
				);
			}
		});
	}, []);

	return (
		<ThemeConfigContext.Provider
			value={{ centeredLogin, customLogo, logoLogin, logoMenu, enterpriseName }}
		>
			{children}
		</ThemeConfigContext.Provider>
	);
}

export function useThemeConfig(): ThemeConfigContextValue {
	return useContext(ThemeConfigContext);
}
